import React from "react";
import FacebookContent from './../Components/FacebookContent.jsx'
export default class SuccessRegistration extends React.Component {

	componentDidMount = () => {
		window.gtm.loadAccount("successregistration");
	}

	render() {
		let T = window.Texts.registration;
		return (
			<div className="success-registered-page">
				<div className="cover">
					<div className="headline">
						<div className="succcess-ordered">
							<p>{T.successText}</p>
						</div>
						<h1>{T.successTitle}</h1>
					</div>
					<div className="inner-750">
						<FacebookContent />
					</div>
				</div>
			</div>
		);
	}
}